import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useIsConciergePage = () => {
  const location = useLocation();

  return useMemo(() => {
    return location.pathname.startsWith("/concierge");
  }, [location.pathname]);
};
